import { sha512 } from 'js-sha512';
import { getActiveProfileToken } from '../utils/profileStorage';

const URL = "https://api.fallaplazarodrigo.es:999";
// Exportada con otro nombre para no chocar con el `URL` global del navegador
// (new URL(...)) en los archivos que la importen.
export const API_BASE_URL = URL;

export const getToken = () =>
  getActiveProfileToken();

/* Site content */
export async function GetSiteContent() {
    const response = await fetch(`${URL}/Site/Content`);
    const data = await response.json();
    return { response, data };
}

export async function UploadHomepageRepresentativesCover(formData) {
    const response = await fetch(`${URL}/Site/Homepage/RepresentativesCover`, {
        method: 'POST',
        headers: { token: getToken() },
        body: formData,
    });
    const data = await response.json();
    return { response, data };
}

/* Main sponsors shown on the home carousel */
export async function GetMainSponsors() {
    const response = await fetch(`${URL}/Sponsors/Main`);
    const data = await response.json();
    return { response, data };
}

export async function GetMainSponsorsAdmin() {
    const response = await fetch(`${URL}/Sponsors/Main/Admin`, { headers: { token: getToken() } });
    const data = await response.json();
    return { response, data };
}

export async function CreateMainSponsor(formData) {
    const response = await fetch(`${URL}/Sponsors/Main`, { method: 'POST', headers: { token: getToken() }, body: formData });
    const data = await response.json();
    return { response, data };
}

export async function UpdateMainSponsor(id, formData) {
    const response = await fetch(`${URL}/Sponsors/Main/${id}`, { method: 'PUT', headers: { token: getToken() }, body: formData });
    const data = await response.json();
    return { response, data };
}

export async function DeactivateMainSponsor(id) {
    const response = await fetch(`${URL}/Sponsors/Main/${id}`, { method: 'DELETE', headers: { token: getToken() } });
    const data = await response.json();
    return { response, data };
}

/* User */

export async function CreateUser(userData) {
    const response = await fetch(`${URL}/Users/CreateAccount`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify(userData)
    });
    const data = await response.json();
    return { response, data };
}

export async function UpdateUserProfile(profileData) {
    console.log("Enviando datos al servidor:", profileData);
    const response = await fetch(`${URL}/Users/UpdateOwnAccount`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            token: getToken(),
        },
        body: JSON.stringify(profileData),
    });
    const data = await response.json();
    console.log("Respuesta del servidor:", data);
    return { response, data };
}

export async function GetToken(username, password) {
    let data = {
        Username: username,
        Password: sha512(password)
    };
    const response = await fetch(`${URL}/Users/GetToken`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        redirect: "follow",
        body: JSON.stringify(data),
    });
    const json = await response.json();
    return { response, json };
}

export async function GetAllAccounts() {
    const response = await fetch(`${URL}/Users/GetAllAccounts`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        }
    });
    const data = await response.json();
    return { response, data };
}

export async function UpdateUserRank(userId, newRank) {
    const response = await fetch(`${URL}/Users/UpdateUserRank`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify({
            Id: userId,
            userRank: newRank
        })
    });
    const data = await response.json();
    return { response, data };
}

export async function RemoveAccount(userId) {
    const response = await fetch(`${URL}/Users/RemoveAccount`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify({
            Id: userId
        })
    });
    const data = await response.json();
    return { response, data };
}

export async function GetUserData() {
    const token = getToken();
    if (!token) return { user: null, isAdmin: false };

    const response = await fetch(`${URL}/Users/GetAccountByToken`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        }
    });

    const data = await response.json();
    if (response.ok) {
        return { user: data, isAdmin: data.userRank === 3 };
    } else {
        return { user: null, isAdmin: false };
    }
}

/* User */

/* Events */
// Agregar evento (notificación)
export async function AddEvent(notificationData) {
    const response = await fetch(`${URL}/Events/AddEvent`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify(notificationData)
    });
    const data = await response.json();
    return { response, data };
}

// Obtener todos los eventos (notificaciones)
export async function GetAllEvents() {
    const response = await fetch(`${URL}/Events/GetAllEvents`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        }
    });
    const data = await response.json();
    return { response, data };
}
// Actualizar evento completo
export async function UpdateEvent(id, eventData) {
    const response = await fetch(`${URL}/Events/UpdateEvent/${id}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify(eventData)
    });
    const data = await response.json();
    return { response, data };
}

export async function GetEventById(id) {
    const response = await fetch(`${URL}/Events/GetEventById/${id}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        }
    });
    const data = await response.json();
    return { response, data };
}


// Eliminar evento
export async function DeleteEvent(id) {
    const response = await fetch(`${URL}/Events/DeleteEvent/${id}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        }
    });
    const data = await response.json();
    return { response, data };
}

/* Events */

/* Polls */
export async function AddPoll(pollData) {
  const response = await fetch(`${URL}/Polls/AddPoll`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "token": getToken()
    },
    body: JSON.stringify(pollData)
  });
  const data = await response.json();
  return { response, data };
}

export async function GetAllPolls() {
    const response = await fetch(`${URL}/Polls/GetAllPolls`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        }
    });
    const data = await response.json();
    return { response, data };
}


export async function MakeUserPermanent(userId) {
    const response = await fetch(`${URL}/Users/MakePermanent`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify({
            Id: userId
        })
    });
    const data = await response.json();
    return { response, data };
}

export async function GetPollById(Id, options = {}) {
    const token = options.tokenOverride || getToken();
    const response = await fetch(`${URL}/Polls/GetPollById`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "token": token
        },
        body: JSON.stringify({ id: Id })
    });

    if (!response.ok) {
        throw new Error(`Error fetching poll: ${response.statusText}`);
    }

    const data = await response.json();
    return { response, data };
}



export async function SubmitSurveyAnswers(pollId, userPayload) {
    const response = await fetch(`${URL}/Polls/SubmitSurveyAnswers`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify({ pollId, userPayload })
    });
    const data = await response.json();
    return { response, data };
}

export async function GetVotedData(pollId) {
    const response = await fetch(`${URL}/Polls/GetVotedData/`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify({ Id: pollId })
    });
    const data = await response.json();
    return { response, data };
}

export async function UpdateVoted(pollId, votedData) {
    const response = await fetch(`${URL}/Polls/UpdateVoted`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify({ id: pollId, voted: votedData })
    });

    const data = await response.json();
    return { response, data };
}

export async function RemoveUserVote(pollId, dni) {
    const response = await fetch(`${URL}/Polls/RemoveUserVote`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify({ pollId, dni })
    });
    const data = await response.json();
    return { response, data };
}

export async function UpdatePollStatus(pollId, statusData) {
    const response = await fetch(`${URL}/Polls/UpdatePollStatus`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify({ id: pollId, ...statusData })
    });
    const data = await response.json();
    return { response, data };
}

export async function DeletePoll(pollId) {
    const response = await fetch(`${URL}/Polls/DeletePoll`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify({ id: pollId })
    });
    const data = await response.json();
    return { response, data };
}

export async function UpdatePoll(pollData) {
  const response = await fetch(`${URL}/Polls/UpdatePoll`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "token": getToken()
    },
    body: JSON.stringify(pollData)
  });
  const data = await response.json();
  return { response, data };
}

/* Polls */

/* Notifications */

export async function SaveToken(_token, _userId) {
    const response = await fetch(`${URL}/Notifications/SaveToken`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify({ token: _token, userId: _userId })
    });
    const data = await response.json();
    return { response, data };
}

export async function RemoveToken(_token) {
    const response = await fetch(`${URL}/Notifications/RemoveToken`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify({ token: _token })
    });
    const data = await response.json();
    return { response, data };
}

/* Notifications */

/* Json */

export async function CreateYearFolder(year) {
    console.log("CreateYearFolder - year:", year);
    const response = await fetch(`${URL}/Json/CreateYearFolders`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify({ year })
    });
    const data = await response.json();
    console.log("CreateYearFolder - response:", response);
    return { response, data };
}

export async function UploadImage(formData) {
    const response = await fetch(`${URL}/Json/UploadImage`, {
        method: "POST",
        headers: {
            "token": getToken()
        },
        body: formData
    });

    const data = await response.json();
    return { response, data };
}

export async function UpdateHistoricalContent(formData) {
    const response = await fetch(`${URL}/Json/HistoricalContent`, {
        method: 'POST',
        headers: { token: getToken() },
        body: formData,
    });
    const data = await response.json();
    return { response, data };
}

export async function GetYears() {
    const response = await fetch(`${URL}/Json/GetYears?details=1`, {
        method: "GET",
        headers: {
            "token": getToken()
        }
    });
    const data = await response.json();
    return { response, data };
}

export async function GetRepresentantes() {
  const response = await fetch(`${URL}/Json/Representantes`, {
    method: "GET",
    headers: {
      "token": getToken()
    }
  });
  const data = await response.json();
  return { response, data };
}

export async function GetLlibrets() {
  const response = await fetch(`${URL}/Json/Llibrets`, {
    method: "GET",
    headers: { "token": getToken() }
  });
  const data = await response.json();
  return { response, data };
}

export async function GetBocetos() {
  const response = await fetch(`${URL}/Json/Bocetos`, {
    method: "GET",
    headers: { "token": getToken() }
  });
  const data = await response.json();
  return { response, data };
}

export async function GetPremios() {
  const response = await fetch(`${URL}/Json/Premios`, {
    method: "GET",
    headers: { "token": getToken() }
  });
  const data = await response.json();
  return { response, data };
}





/* Json */

/* Sponsors (Patrocinadores) */

// Obtener todos los patrocinadores
export async function GetAllSponsors() {
    const response = await fetch(`${URL}/QR/sponsors`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        }
    });
    const data = await response.json();
    return { response, data };
}

// Crear un patrocinador y subir la imagen
export async function AddSponsor(formData) {
    const response = await fetch(`${URL}/QR/UploadSponsorImage`, {
        method: "POST",
        headers: {
            "token": getToken()
        },
        body: formData
    });
    const data = await response.json();
    return { response, data };
}

// Editar un patrocinador
export async function UpdateSponsor(id, sponsorData) {
    const isFormData = sponsorData instanceof FormData;
    const response = await fetch(`${URL}/QR/sponsors/${id}`, {
        method: "PUT",
        headers: isFormData
            ? { "token": getToken() }
            : { "Content-Type": "application/json", "token": getToken() },
        body: isFormData ? sponsorData : JSON.stringify(sponsorData)
    });
    const data = await response.json();
    return { response, data };
}

// Eliminar un patrocinador
export async function DeleteSponsor(id) {
    const response = await fetch(`${URL}/QR/DeleteSponsor/${id}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        }
    });
    const data = await response.json();
    return { response, data };
}

// Obtener un patrocinador por su ID
export async function GetSponsorById(id) {
    const response = await fetch(`${URL}/QR/sponsors/${id}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        }
    });
    const data = await response.json();
    return { response, data };
}

/* Sponsors (Patrocinadores) */

/* QR Codes */

// Generar código QR para un patrocinador
export async function GenerateQRCode(sponsorId) {
    try {
        const response = await fetch(`${URL}/QR/GenerateQR`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": getToken()
            },
            body: JSON.stringify({ sponsorId })
        });
        const data = await response.json();

        return { response, data };  // Asegúrate de que 'data.qrImage' tenga la imagen en base64
    } catch (error) {
        console.error("Error generando el QR:", error);
        throw error;
    }
}


// Validar código QR
export async function ValidateQRCode(token) {
    const response = await fetch(`${URL}/QR/ValidateQR?token=${token}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    const data = await response.json();
    return { response, data };
}


// Obtener perfiles de un usuario
export async function GetProfiles(userId) {
    const response = await fetch(`${URL}/Users/${userId}/profiles`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        }
    });
    const data = await response.json();
    return { response, data };
}

// Añadir un nuevo perfil
export async function AddProfile(userId, profileName) {
    const response = await fetch(`${URL}/Users/${userId}/profiles`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify({ profileName })
    });
    const data = await response.json();
    return { response, data };
}

// Eliminar un perfil
export async function DeleteProfile(userId, profileId) {
    const response = await fetch(`${URL}/Users/${userId}/profiles/${profileId}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        }
    });
    const data = await response.json();
    return { response, data };
}

export async function AddPersonalConsumption(tipoBebida) {
    const response = await fetch(`${URL}/personal/add`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify({ tipoBebida })
    });
    const data = await response.json();
    return { response, data };
}

export async function GetPersonalStats() {
    const token = getToken();
    const response = await fetch(`${URL}/personal/stats`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    });

    const data = await response.json();
    return { response, data };
}

export async function GetMonthlySummary() {
    const response = await fetch(`${URL}/personal/monthly-summary`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "token": getToken(),
        },
    });
    const data = await response.json();
    return { response, data };
}

export async function DeleteVote(pollId, dni) {
  const response = await fetch(`${URL}/Polls/DeleteVote`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      token: getToken(),
    },
    body: JSON.stringify({ pollId, dni }), // ✅ así lo espera el backend
  });

  const data = await response.json();
  return { response, data };
}

export async function GetPollRegistrationSummary(pollId, accountTokens = []) {
    const response = await fetch(`${URL}/Polls/GetRegistrationSummary`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            token: getToken(),
        },
        body: JSON.stringify({ pollId, accountTokens }),
    });
    const data = await response.json().catch(() => ({}));
    return { response, data };
}

export async function SavePollRegistrationCart(pollId, registrants, paymentChoice = "none") {
    const response = await fetch(`${URL}/Polls/SaveRegistrationCart`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            token: getToken(),
        },
        body: JSON.stringify({
            pollId,
            registrants,
            paymentChoice,
            replaceSelection: true,
        }),
    });
    const data = await response.json().catch(() => ({}));
    return { response, data };
}

// Búsqueda administrativa de falleros (solo isPollManager en backend). El
// backend ya filtra los campos devueltos (nunca password/loginToken/dni
// completo/etc.), así que aquí no hay nada que sanear.
export async function AdminSearchUsers(pollId, query) {
    const response = await fetch(
        `${URL}/Polls/${encodeURIComponent(pollId)}/AdminSearchUsers?q=${encodeURIComponent(query || '')}`,
        {
            method: "GET",
            headers: { token: getToken() },
        }
    );
    const data = await response.json().catch(() => ({}));
    return { response, data };
}

// Inscribe/responde una encuesta en nombre de otra persona (solo
// isPollManager). Nunca se envía contraseña ni token de la persona: el
// backend identifica al administrador por SU PROPIO token de sesión.
export async function AdminRegisterUser(pollId, { beneficiaryUserId, answers = [], paymentChoice = "none" }) {
    const response = await fetch(`${URL}/Polls/${encodeURIComponent(pollId)}/AdminRegistration`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            token: getToken(),
        },
        body: JSON.stringify({ beneficiaryUserId, answers, paymentChoice }),
    });
    const data = await response.json().catch(() => ({}));
    return { response, data };
}

export async function VerifyCaptcha(captchaToken) {
    const response = await fetch(`${URL}/Captcha`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ captchaToken }),
    });
    const data = await response.json();
    return { response, data };
}

export async function GetAllPollsAdmin() {
    const response = await fetch(`${URL}/Polls/GetAllPollsAdmin`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        }
    });
    const data = await response.json().catch(() => ([]));
    return { response, data };
}

export async function SendContactEmail(contactData) {
    const response = await fetch(`${URL}/contact/send`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(contactData),
    });

    const data = await response.json().catch(() => ({}));
    return { response, data };
}

export async function GetInstagramNews(limit = 3, after = "") {
    const query = new URLSearchParams();
    query.set("limit", String(limit));
    if (after) query.set("after", after);

    const response = await fetch(`${URL}/Instagram/News?${query.toString()}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });

    const data = await response.json().catch(() => ({}));
    return { response, data };
}

export async function GetAdminEmails(limit = 20) {
    const response = await fetch(`${URL}/admin/emails?limit=${encodeURIComponent(limit)}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            token: getToken(),
        },
    });

    const data = await response.json().catch(() => ([]));
    return { response, data };
}

export async function GetAdminEmailById(id) {
    const response = await fetch(`${URL}/admin/emails/${encodeURIComponent(id)}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            token: getToken(),
        },
    });

    const data = await response.json().catch(() => ({}));
    return { response, data };
}

export async function RespondAdminEmail(payload) {
    const response = await fetch(`${URL}/admin/emails/respond`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            token: getToken(),
        },
        body: JSON.stringify(payload),
    });

    const data = await response.json().catch(() => ({}));
    return { response, data };
}

export async function UpdateAdminEmailReadStatus(id, read = true) {
    const response = await fetch(`${URL}/admin/emails/${encodeURIComponent(id)}/read`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            token: getToken(),
        },
        body: JSON.stringify({ read }),
    });

    const data = await response.json().catch(() => ({}));
    return { response, data };
}

export async function DeleteAdminEmail(id) {
    const response = await fetch(`${URL}/admin/emails/${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            token: getToken(),
        },
    });

    const data = await response.json().catch(() => ({}));
    return { response, data };
}

export async function UploadPDF(formData) {
    const token = getToken();
    const response = await fetch(`${URL}/PDF/upload`, {
        method: "POST",
        headers: { 'token': token }, // NO pongas Content-Type con FormData
        body: formData,
    });
    const data = await response.json().catch(() => ({}));
    return { response, data };
}

// Listar PDFs
export async function GetPDFs() {
    const token = getToken();
    const response = await fetch(`${URL}/PDF/pdfs`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            token,
        },
    });
    const json = await response.json().catch(() => ({}));

    const data = Array.isArray(json) ? json :
        Array.isArray(json?.data) ? json.data : [];

    return { response, data };
}

// Actualizar PDF (admin). formData puede traer 'title' y/o 'pdf' para reemplazar archivo
export async function UpdatePDF(pdfId, formData) {
    const token = getToken();
    const response = await fetch(`${URL}/PDF/update/${pdfId}`, {
        method: "PUT",
        headers: { 'token': token }, // NO pongas Content-Type con FormData
        body: formData,
    });
    const data = await response.json().catch(() => ({}));
    return { response, data };
}

// Borrar PDF (admin)
export async function DeletePDF(pdfId) {
    const token = getToken();
    const response = await fetch(`${URL}/PDF/delete/${pdfId}`, {
        method: "DELETE",
        headers: { 'token': token },
    });
    const data = await response.json().catch(() => ({}));
    return { response, data };
}

// -----------------------------
//  PUBLICIDAD
// -----------------------------

export async function GetAllPublicidad() {
    const res = await fetch(`${URL}/Publicidad/GetAll`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "token": getToken(),
        },
    });

    return { response: res, data: await res.json() };
}

export async function GetPublicidadById(id) {
    const res = await fetch(`${URL}/Publicidad/Get/${id}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "token": getToken(),
        },
    });

    return { response: res, data: await res.json() };
}

export async function AddPublicidad(formData) {
    const res = await fetch(`${URL}/Publicidad/Add`, {
        method: "POST",
        headers: {
            "token": getToken(),
        },
        body: formData
    });

    return { response: res, data: await res.json() };
}

export async function UpdatePublicidad(id, formData) {
    const res = await fetch(`${URL}/Publicidad/Update/${id}`, {
        method: "PUT",
        headers: { "token": getToken() },
        body: formData,
    });

    return { response: res, data: await res.json() };
}

export async function DeletePublicidad(id) {
    const res = await fetch(`${URL}/Publicidad/Delete/${id}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            "token": getToken()
        },
        body: JSON.stringify({ id })
    });

    return { response: res, data: await res.json() };
}

export async function CreateRedsysPayment(pollId, beneficiaries, returnMode = "web", gatewayMethod = "card") {
  const response = await fetch(`${URL}/Payments/Redsys/Create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      token: getToken(),
    },
    body: JSON.stringify({ pollId, beneficiaries, returnMode, gatewayMethod }),
  });

  const data = await response.json().catch(() => ({}));
  return { response, data };
}

export async function GetRedsysStatus(order) {
  const response = await fetch(`${URL}/Payments/Redsys/Status?order=${encodeURIComponent(order)}`, {
    method: "GET",
    headers: { token: getToken() },
  });
  const data = await response.json().catch(() => ({}));
  return { response, data };
}

// Sin token/sesión a propósito: la página de resultado del pago puede
// abrirse en un navegador externo (Capacitor Browser, Safari, Chrome) que
// no comparte localStorage/sessionStorage con la app. El receiptToken (va
// embebido en la URL de retorno que el propio backend construye) es lo que
// autoriza la consulta, no la sesión.
export async function GetRedsysPublicStatus(order, receiptToken) {
  const response = await fetch(
    `${URL}/Payments/Redsys/PublicStatus?order=${encodeURIComponent(order)}&receiptToken=${encodeURIComponent(receiptToken || '')}`,
    { method: "GET" }
  );
  const data = await response.json().catch(() => ({}));
  return { response, data };
}

export async function GetAccountByTokenRaw(rawToken) {
  const response = await fetch(`${URL}/Users/GetAccountByToken`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      token: rawToken, // 👈 token del perfil que quieres consultar
    },
  });

  const data = await response.json().catch(() => ({}));
  return { response, data };
}

/* Notificaciones push (vía backend — la API key de OneSignal vive en el servidor) */

export async function SendPushNotification({ title, body, route, externalIds, publicationId }) {
  const response = await fetch(`${URL}/Notifications/SendPush`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      token: getToken(),
    },
    body: JSON.stringify({ title, body, route, externalIds, publicationId }),
  });
  const data = await response.json().catch(() => ({}));
  return { response, data };
}

/* Encuestas: usuarios pendientes de contestar */

export async function GetNonRespondents(pollId) {
  const response = await fetch(`${URL}/Polls/GetNonRespondents`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      token: getToken(),
    },
    body: JSON.stringify({ id: pollId }),
  });
  const data = await response.json().catch(() => ({}));
  return { response, data };
}

/* Analítica propia */

export async function TrackEvent(payload) {
  const response = await fetch(`${URL}/Analytics/TrackEvent`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      token: getToken(),
    },
    body: JSON.stringify(payload),
  });
  const data = await response.json().catch(() => ({}));
  return { response, data };
}

export async function GetAppStats(days = 30) {
  const response = await fetch(`${URL}/Analytics/GetStats`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      token: getToken(),
    },
    body: JSON.stringify({ days }),
  });
  const data = await response.json().catch(() => ({}));
  return { response, data };
}
